// extracted by mini-css-extract-plugin
module.exports = {"or":"styles_or__2tXvT","inputWrap":"styles_inputWrap__1Tcix","input":"styles_input__3KjJP"};